import config from "config.ts";

import logger from "../utils/logger.js";

/**
 * logger function to 'throw exception' to aws log and/or console
 * @param imagePath  - string full path of image, e.g. 'images/locked-circled.svg' or 'images/about-us/about-us.jpg
 * @param callback - function to be called after image is loaded and parameter is the image
 *
 */
const getAsyncImage = async (imagePath, callback) => {
  if (!imagePath) {
    return null;
  }
  if (callback) {
    callback(`${config.api.resource}/assets/${imagePath}`);
  } else return `${config.api.resource}/assets/${imagePath}`;
};

logger.defaultProps = {
  image: { name: "locked-circled", ext: "svg" },
};

export default getAsyncImage;
